import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { tap, timeout } from 'rxjs/operators';
import { BBResponseContainer } from '../common-services/response-container';
import { LibraryConfiguration } from '../masterdata/models/libraryConfiguration';

@Injectable({
  providedIn: 'root'
})
export class MdmLibraryConfigurationService {

  readonly LIBRARYCONFIGURATION = "admin/mdm/generic/";

  constructor(private http: HttpClient) { }

  addLibraryConfiguration(libConfigData: LibraryConfiguration) {
    let url = environment.BB_MDMSERVICE_URL + this.LIBRARYCONFIGURATION + libConfigData.lab._id + '/libTypes';
    return this.http.post<any>(url, libConfigData).pipe(timeout(environment.defaultTimeout));

  }
  updateLibraryConfiguration(libConfigData: LibraryConfiguration) {
    let url = environment.BB_MDMSERVICE_URL + this.LIBRARYCONFIGURATION + libConfigData.lab._id + '/libTypes/' + libConfigData._id;
    return this.http.put<any>(url, libConfigData).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

}